
<!--============================ new dashdoard design ==============================-->

<section class="mis-dropdown-1">
    <div class="container">
        <div class="dash-segment-toggle-wrap">
            <div class="dash-segment-toggle" role="group" aria-label="Dashboard segment">
                <button type="button" class="dash-segment-toggle__btn"
                    [class.dash-segment-toggle__btn--active]="selectedSegment === 'College'"
                    (click)="onSegmentChange('College')">College</button>
                <button type="button" class="dash-segment-toggle__btn"
                    [class.dash-segment-toggle__btn--active]="selectedSegment === 'School'"
                    (click)="onSegmentChange('School')">School</button>
            </div>
        </div>
        <div class="row" *ngIf="data">
            <div class="cctvmain-dashboard">
                <div class="main-box-1">
                    <div class="card-box-1">
                        <h5 class="dvr-title">DVR Status</h5>
                        <div class="DVR-box">
                            <div class="cctv_dvr">
                                <div class="dvr-detail">
                                    <div class="dvr_circle" routerLink="/dvr-nvrstatus">
                                        <img src="../../assets/image/dvr-image.svg" alt="dvrimage">
                                    </div>
                                    <div class="dvr-total">
                                        <div class="dvr-name" routerLink="/dvr-nvrstatus">DVR/NVR</div>
                                        <div class="dvr-num" routerLink="/dvr-nvrstatus">
                                            {{data.overallCctvDashboardDetails?.totalDvrs | million}}</div>
                                    </div>
                                </div>
                                <div class="dvr-status">
                                    <div class="dvr-connect">
                                        <h5 class="dvr-connected">Connected</h5>
                                        <h5 class="dvr-percentage">
                                            {{math.round((data.overallCctvDashboardDetails?.dvrTotalConnected/data.overallCctvDashboardDetails?.totalDvrs)*100)}}%
                                        </h5>
                                    </div>
                                    <div class="dvr-notconnect">
                                        <h5 class="dvr-notconnected">Not connected</h5>
                                        <h5 class="dvr-percentage">
                                            {{math.round((data.overallCctvDashboardDetails?.dvrTotalNotConnected/data.overallCctvDashboardDetails?.totalDvrs)*100)}}%
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="connt-item">
                                <div class="connect-background">
                                    <div class="dvr-conntdetail">
                                        <div class="dvr_conntcircle" routerLink="/dvr-connected">
                                            <img src="../../assets/image/drvconneted.svg" alt="connectedimage">
                                        </div>
                                        <div class="dvrconnet-total">
                                            <div class="dvrconnet-name" routerLink="/dvr-connected">Connected</div>
                                            <div class="dvrconnet-num" routerLink="/dvr-connected">
                                                {{data.overallCctvDashboardDetails?.dvrTotalConnected | million}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="notconnect-background">
                                    <div class="dvr-notconnetdetail">
                                        <div class="dvr_notconnectcircle" routerLink="/dvr-notconnected">
                                            <img src="../../assets/image/dvr-notconnected.svg" alt="notconnectedimage">
                                        </div>
                                        <div class="dvr-total">
                                            <div class="dvr-name" routerLink="/dvr-notconnected">Not Connected</div>
                                            <div class="dvrnotconnect-num" routerLink="/dvr-notconnected">
                                                {{data.overallCctvDashboardDetails?.dvrTotalNotConnected | million}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main-box-2">
                    <div class="card-box-2">
                        <h5 class="cctv-title">CCTV Camera Status</h5>
                        <div class="DVR-box">
                            <div class="connt-item1">
                                <div class="camera_dvr">
                                    <div class="dvr-detail">
                                        <div class="install_circle" routerLink="/home">

                                            <img src="../../assets/image/install_cctv.svg" alt="installimage">
                                        </div>
                                        <div class="dvr-total">
                                            <div class="dvr-name" routerLink="/home">Installed</div>
                                            <div class="dvr-num" routerLink="/home">
                                                {{data.overallCctvDashboardDetails?.totalCamerasInstalled | million}}
                                            </div>
                                        </div>
                                    </div>
                             


                                </div>
                                <div class="cctvnotstreaming-background">
                                    <div class="dvr-notstreamingdetail">
                                        <div class="dvr-notstreamingcircle" routerLink="/dashboardcctvstreaming">
                                            <img src="../../assets/image/streaming change.svg" alt="streaming">
                                        </div>
                                        <div class="dvrnotstreaming-total">
                                            <div class="dvrnotstreaming-name" routerLink="/dashboardcctvstreaming">
                                                Streaming</div>
                                            <div class="dvrnotstreaming-num" routerLink="/dashboardcctvstreaming">
                                                {{data.overallCctvDashboardDetails?.totalVideoStreaming | million}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="connt-item2">
                                <div class="cctvconnect-background">
                                    <div class="dvr-conntdetail">
                                        <div class="dvr_conntcircle" routerLink="/dashboardcctv">
                                            <img src="../../assets/image/drvconneted.svg" alt="connectedimage">
                                        </div>
                                        <div class="dvrconnet-total">
                                            <div class="dvrconnet-name" routerLink="/dashboardcctv">Connected</div>
                                            <div class="dvrconnet-num" routerLink="/dashboardcctv">
                                                {{data.overallCctvDashboardDetails?.totalConnected | million}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cctvnotconnect-background1">
                                    <div class="dvr-notconnetdetail">
                                        <div class="dvr_notconnectcircle1" routerLink="/dashboardcctvnotstreaming">
                                            <img src="../../assets/image/bxs_cctv not streaming.svg" alt="notstreaming">
                                        </div>
                                        <div class="dvr-total">
                                            <div class="dvr-name" routerLink="/dashboardcctvnotstreaming">No Streaming
                                            </div>
                                            <div class="dvrnotconnect-num" routerLink="/dashboardcctvnotstreaming">
                                                {{data.overallCctvDashboardDetails?.totalVideoNotStreaming | million}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="connt-item3">
                                <div class="streaming-background">
                                    <div class="dvr-conntdetail">
                                        <div class="streaming_circle" routerLink="/dashboardcctvnotconnected">
                                            <img src="../../assets/image/dvr-notconnected.svg" alt="notconnected">
                                        </div>
                                        <div class="dvrconnet-total">
                                            <div class="dvrconnet-name" routerLink="/dashboardcctvnotconnected">Not
                                                Connected</div>
                                            <div class="dvrconnet-num" routerLink="/dashboardcctvnotconnected">
                                                {{data.overallCctvDashboardDetails?.totalNotConnected | million}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="novideo-background">
                                    <div class="dvr-notconnetdetail">
                                        <div class="novideo_circle" routerLink="/dashboardnovideo">
                                            <img src="../../assets/image/novideo_cctv.svg" alt="novideoimage">
                                        </div>
                                        <div class="dvr-total">
                                            <div class="dvr-name" routerLink="/dashboardnovideo">No Video</div>
                                            <div class="dvrnotconnect-num" routerLink="/dashboardnovideo">
                                                {{data.overallCctvDashboardDetails?.totalNoVideo | million}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<!--========= end new dashboard ==============-->

<!--=========================== section end =======================-->

<!--=========================== connected ==========================-->
<!-- <section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="topcampus_flex">
                    <div class="d-flex justify-content-between">
                        <h6 class="ccdash__title connect_color_1 " (click)=" getConnected()"
                            [ngClass]="{disableColorGreen_1:currentTopSelectedValue!='connected'}"><u>Top 5 Campus
                                (Connected)</u></h6>
                        <h6 class="ccdash__title not_color_1 " (click)="getNotConnected()"
                            [ngClass]="{disableColorRed_1:currentTopSelectedValue!='not connected'}"><u>Top 5 Campus
                                (Not
                                Connected)</u></h6>
                        <h6 class="ccdash__title stream_color_1 " (click)="getVideoStreaming()"
                            [ngClass]="{disableColorDarkviolet_1:currentTopSelectedValue!='video streaming'}"><u>Top 5
                                Campus (Video
                                Streaming)</u></h6>
                        <h6 class="ccdash__title not-stream_color_1 " (click)="getNotVideoStreaming()"
                            [ngClass]="{disableColorOrange_1:currentTopSelectedValue!='Video Not Streaming'}"><u>Top 5
                                Campus
                                (Video Not Streaming)</u></h6>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered campus_table" cellspacing="0" cellpadding="0" width="100%">
                            <thead class="theadfixed">
                                <tr>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>Campus</th>
                                    <th>Installed</th>
                                    <th>Connected</th>
                                    <th>NotConnected</th>
                                    <th>Streaming</th>
                                    <th>No Video</th>
                                    <th>{{connectedStatus}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <div class="nodatafound" *ngIf="!isLoading">
                                        <div *ngIf="connect.length<=0">
                                            <section class="section_one">
                                                <div class="cctvcouncelling__sec">
                                                    <div class="councellist__flex">
                                                        <div>
                                                            <div class="nodata_center">
                                                                <figure class="mb-0">
                                                                    <img src="../../../../assets/image/nodata.png"
                                                                        alt="nodata" class="nodata">
                                                                </figure>
                                                                <p class="no_data">No Data Found</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </tr>
                            </tbody>


                            <tbody *ngFor="let data of connect">
                                <tr>
                                    <td>{{data.stateName}}</td>
                                    <td>{{data.cityName}}</td>
                                    <td>{{data.campusName}}</td>
                                    <td class="connect-table">{{data.totalCamerasInstalled}}</td>
                                    <td class="connect-table"><span
                                            [ngClass]="{disableColorGreen:currentTopSelectedValue ==='connected'}">{{data.totalConnected}}</span>
                                    </td>
                                    <td class="connect-table"><span
                                            [ngClass]="{disableColorRed:currentTopSelectedValue ==='not connected'}">{{data.totalNotConnected}}</span>
                                    </td>
                                    <td class="connect-table"><span
                                            [ngClass]="{disableColorDarkviolet:currentTopSelectedValue ==='video streaming'}">{{data.totalVideoStreaming}}</span>
                                    </td>

                                    <td class="connect-table"><span
                                            [ngClass]="{disableColorOrange:currentTopSelectedValue ==='Video Not Streaming'}">{{data.totalVideoNotStreaming}}</span>
                                    </td>
                                    <td class="connect-table"><span
                                            [ngClass]="{disableColorGreen:currentTopSelectedValue === 'connected',disableColorRed:currentTopSelectedValue === 'not connected',disableColorDarkviolet:currentTopSelectedValue === 'video streaming',disableColorOrange:currentTopSelectedValue ==='Video Not Streaming'}">{{data.status}}%</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->


<!--======================== loader ========================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>